import { useCallback, useRef } from 'react';

import { importCanvasConfetti } from '@perpay-web/fintech/utils/imports/importCanvasConfetti';
import { useMountAndUnmount } from '@perpay-web/hooks/useMountAndUnmount';

const FIREWORKS_DURATION_MS = 4000;

// From https://www.kirilv.com/canvas-confetti/#fireworks
function fireHelper(confetti, duration) {
    const animationEnd = Date.now() + duration;
    const defaults = {
        startVelocity: 30,
        spread: 360,
        ticks: 60,
        zIndex: 0,
    };

    function randomInRange(min, max) {
        return Math.random() * (max - min) + min;
    }

    const interval = setInterval(() => {
        const timeLeft = animationEnd - Date.now();

        if (timeLeft <= 0) {
            clearInterval(interval);
            return;
        }

        const particleCount = 50 * (timeLeft / duration);
        // since particles fall down, start a bit higher than random
        confetti({
            ...defaults,
            particleCount,
            origin: { x: randomInRange(0.1, 0.3), y: Math.random() - 0.2 },
        });
        confetti({
            ...defaults,
            particleCount,
            origin: { x: randomInRange(0.7, 0.9), y: Math.random() - 0.2 },
        });
    }, 250);

    return interval;
}

// A wrapper around fireHelper. This uses dependency injection to provide the
// async-loaded 'canvas-confett' confetti function to the fireHelper function.
function fire(duration) {
    importCanvasConfetti().then((confetti) => fireHelper(confetti, duration));
}

export const useFireworks = () => {
    const timerIdRef = useRef(null);
    const startFireworks = useCallback((duration = FIREWORKS_DURATION_MS) => {
        timerIdRef.current = fire(duration);
    }, []);
    const stopFireworks = useCallback(() => {
        if (timerIdRef.current === null) {
            return;
        }
        window.clearInterval(timerIdRef.current);
    }, []);

    useMountAndUnmount(() => () => stopFireworks());

    return {
        startFireworks,
        stopFireworks,
    };
};
